var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"page_not_found"},[_c('div',{staticClass:"status"},[_c('picture',[_c('img',{staticClass:"background_alert",attrs:{"src":_vm.alert,"alt":"Alert logo"}})]),_vm._m(0),_vm._m(1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('span',{staticClass:"status_code"},[_vm._v("404")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('h2',[_c('span',{staticClass:"status_message"},[_vm._v("Il semblerait que vous vous soyez égaré en chemin")])])
}]

export { render, staticRenderFns }